import data from './data'
import { Link } from 'react-router-dom'
import { MdOutlineDarkMode } from 'react-icons/md'
import { useModalContext } from '../../context/modal-context'
import './navbar.css'

const Navbar = () => {
  const {showModalHandler} = useModalContext();

  return (
    <nav>
      <div className="container nav__container">
        <ul className='nav__menu'>
          {
            data.map(item => (
              <li key={item.id}>
                {item.link.startsWith('/')
                  ? <Link to={item.link}>{item.title}</Link>
                  : <a href={item.link}>{item.title}</a>}
              </li>
            ))
          }
        </ul>
        <button id='theme__icon' onClick={showModalHandler}><MdOutlineDarkMode/></button>
      </div>
    </nav>
  )
}

export default Navbar
